/** Web search providers — keep in sync with cascade-node-server/services/webSearchProviders.js */

export const FEEL_LUCKY_KEY_NAME = 'FEEL_LUCKY_KEY';

export const WEB_SEARCH_PROVIDERS = [
  {
    id: 'brave',
    name: 'Brave Search',
    keyName: 'BRAVE_API_KEY',
    description: 'Brave Search API — privacy-focused web results.',
    docsUrl: 'https://brave.com/search/api/'
  },
  {
    id: 'serper',
    name: 'Serper (Google)',
    keyName: 'SERPER_API_KEY',
    description: 'Serper.dev — Google search results via simple JSON API.',
    docsUrl: 'https://serper.dev/'
  },
  {
    id: 'tavily',
    name: 'Tavily',
    keyName: 'TAVILY_API_KEY',
    description: 'Tavily — search API built for AI agents with clean snippets.',
    docsUrl: 'https://tavily.com/'
  },
  {
    id: 'feel_lucky',
    name: 'I feel lucky!',
    keyName: FEEL_LUCKY_KEY_NAME,
    description: 'No API key — scrapes Google plus Bing or Yahoo HTML results (pseudo-scraper).',
    toggleKey: true,
    noApiKey: true
  }
];

export function isFeelLuckyEnabled(value) {
  return String(value || '').trim().toLowerCase() === 'y';
}

export function normalizeWebSearchProvider(raw) {
  const id = String(raw || 'brave').toLowerCase().trim();
  return WEB_SEARCH_PROVIDERS.some((p) => p.id === id) ? id : 'brave';
}

export function getWebSearchProviderLabel(id) {
  const provider = WEB_SEARCH_PROVIDERS.find((p) => p.id === normalizeWebSearchProvider(id));
  return provider ? provider.name : 'Brave Search';
}
